import http from 'Services/HttpService';
import { baseUrl } from 'Utils/envLoader';

const PortalService = {
    getAccesses: (TokenService_id) => {
        return http.get(`${baseUrl}/cliami/Accesses/user/${TokenService_id}`);
    },
    goto: (AppId) => {
        return http.get(`${baseUrl}/portals/apps/goto/${AppId}`);
    },
};

export default PortalService;
